/**
 * Created by Daniela on 27/09/2016.
 */
import { Component }   from '@angular/core';

@Component({
    template: require('./material-codigo-barra.component.html')
})
export class MaterialCodigoBarraComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-codigo-barra/material-codigo-barra.component.ts
 **/